<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-arrow-right-arrow-left"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Grid de Cards -->
      <div class="cards-container">
        <!-- Coluna Esquerda: Valor e Data -->
        <div class="column-left">
          <!-- Card: Valor e Data -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon values-icon">
                <i class="pi pi-dollar"></i>
              </div>
              <span class="card-header-title">{{ texts.valor_e_data }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Banner de conversao (quando moedas diferentes) -->
                <div class="form-field full" *ngIf="!validaMoedasDasContas()">
                  <div class="conversion-info-banner">
                    <div class="conversion-currencies">
                      <div class="conversion-currency">
                        <img [src]="getFlagUrl(form.moedaDeOrigem?.value)" class="flag-icon" alt="" />
                        <span class="conversion-currency-name">{{ getCurrencyLabel(form.moedaDeOrigem?.value) }}</span>
                      </div>
                      <i class="pi pi-arrow-right conversion-arrow"></i>
                      <div class="conversion-currency">
                        <img [src]="getFlagUrl(form.moedaDeDestino?.value)" class="flag-icon" alt="" />
                        <span class="conversion-currency-name">{{ getCurrencyLabel(form.moedaDeDestino?.value) }}</span>
                      </div>
                    </div>
                    <div class="conversion-rate">
                      <i class="pi pi-chart-line"></i>
                      <span>{{ texts.cotacao_do_dia }}: {{ form.cotacaoDeTransferencia | number:'1.2-4' }}</span>
                    </div>
                  </div>
                </div>
                <!-- Valor (full) -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.valor }} <span class="required">*</span></label>
                  <div class="currency-input-container">
                    <input type="text" pInputText
                      [placeholder]="placeholders.valor"
                      class="currency-input-with-symbol w-full"
                      [value]="montanteStr"
                      (input)="formataCampoMontante($event)"
                      [class.error-field]="isFormSubmitted && !form.valor && form.valor !== 0" />
                    <span class="currency-symbol-inside-input" *ngIf="contasCarregadas && form.conta_id">
                      {{ getSelectedCurrencySymbol(form.conta_id) }}
                    </span>
                  </div>
                </div>
                <!-- Valor Convertido (full, conditional) -->
                <div class="form-field full" *ngIf="!validaMoedasDasContas()">
                  <label class="form-label">{{ labels.valor_convertido }} <span class="required">*</span></label>
                  <div class="currency-input-container">
                    <input type="text" pInputText
                      #valorConvertidoInput
                      [placeholder]="placeholders.valor"
                      class="currency-input-with-symbol w-full"
                      (input)="formataCampoMontante($event, 'valorConvertido')"
                      [class.error-field]="isFormSubmitted && !form.valorConvertido && form.valorConvertido !== 0" />
                    <span class="currency-symbol-inside-input">
                      {{ getSelectedCurrencySymbol(form.contaDestino_id) }}
                    </span>
                  </div>
                </div>
                <!-- Cotacao Calculada (read-only, quando moedas diferentes) -->
                <div class="form-field full" *ngIf="!validaMoedasDasContas()">
                  <label class="form-label">{{ labels.cotacao_calculada }}</label>
                  <input type="text" pInputText [value]="cotacaoCalculadaDisplay" readonly
                    class="w-full readonly-field" />
                </div>
                <!-- Data (full) -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.data }}</label>
                  <div class="date-buttons-group">
                    <button pButton type="button" [label]="labels.hoje"
                      class="p-button-sm"
                      [class.p-button-outlined]="dataSelecionada !== 'hoje'"
                      (click)="selecionarData('hoje')">
                    </button>
                    <button pButton type="button" [label]="labels.ontem"
                      class="p-button-sm"
                      [class.p-button-outlined]="dataSelecionada !== 'ontem'"
                      (click)="selecionarData('ontem')">
                    </button>
                    <span class="calendar-inline-wrapper">
                      <button pButton type="button" [label]="outrosLabel"
                        class="p-button-sm"
                        [class.p-button-outlined]="dataSelecionada !== 'outros'"
                        (click)="abrirCalendario()">
                      </button>
                      <p-calendar #calendario [(ngModel)]="form.emissao"
                        dateFormat="dd/mm/yy" [readonlyInput]="true"
                        [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2030"
                        (onSelect)="onDataSelecionada()"
                        [showIcon]="false"
                        appendTo="body">
                      </p-calendar>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita: Dados da Transferencia -->
        <div class="column-right">
          <!-- Card: Dados da Transferencia -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-file-edit"></i>
              </div>
              <span class="card-header-title">{{ texts.dados_da_transferencia }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Conta Origem (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.conta_origem }} <span class="required">*</span></label>
                  <p-dropdown [options]="contasOptions" optionLabel="label"
                    [(ngModel)]="form.conta_id" optionValue="value"
                    [placeholder]="placeholders.selecionar"
                    [showClear]="false" [filter]="true" appendTo="body"
                    (onChange)="onContaOrigemChange()"
                    [class.error-field]="isFormSubmitted && !form.conta_id">
                    <ng-template pTemplate="dropdownicon">
                      <i class="pi pi-chevron-down"></i>
                    </ng-template>
                    <ng-template pTemplate="selectedItem" let-conta>
                      <div class="dropdown-conta-item" *ngIf="conta">
                        <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ conta.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-conta>
                      <div class="dropdown-conta-item">
                        <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ conta.label }}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                <!-- Conta Destino (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.conta_destino }} <span class="required">*</span></label>
                  <p-dropdown [options]="contasDestinoFiltradasOptions" optionLabel="label"
                    [(ngModel)]="form.contaDestino_id" optionValue="value"
                    [placeholder]="placeholders.selecionar"
                    [showClear]="false" [filter]="true" appendTo="body"
                    (onChange)="onContaDestinoChange()"
                    [class.error-field]="isFormSubmitted && !form.contaDestino_id">
                    <ng-template pTemplate="dropdownicon">
                      <i class="pi pi-chevron-down"></i>
                    </ng-template>
                    <ng-template pTemplate="selectedItem" let-conta>
                      <div class="dropdown-conta-item" *ngIf="conta">
                        <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ conta.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-conta>
                      <div class="dropdown-conta-item">
                        <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ conta.label }}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                <!-- Descricao (full) - Opcional, por ultimo -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.descricao }}</label>
                  <input type="text" pInputText [(ngModel)]="form.descricao"
                    [placeholder]="placeholders.descricao" class="w-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparFormulario()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.salvar"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.atualizar"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

<!-- Card: Lista de Transferencias -->
<div class="table-card">
  <div class="card-header card-header-table">
    <div class="card-header-left">
      <div class="card-header-icon table-icon">
        <i class="pi pi-list"></i>
      </div>
      <span class="card-header-title">{{ texts.lista_de_transferencias }}</span>
    </div>
    <div class="card-header-filters">
      <!-- Filtro Conta (inline no header) -->
      <div class="header-filter-field">
        <p-dropdown [options]="contasFiltroOptions" [(ngModel)]="filtroContaId"
          optionLabel="label" optionValue="value"
          [placeholder]="labels.filtro_conta" [filter]="true"
          filterBy="label" [showClear]="true" appendTo="body"
          [style]="{ width: '100%' }"
          (ngModelChange)="onFiltroCcontaChanged()">
          <ng-template pTemplate="selectedItem" let-conta>
            <div class="dropdown-conta-item" *ngIf="conta">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-conta>
            <div class="dropdown-conta-item">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <!-- Filtro Periodo (inline no header) -->
      <div class="header-filter-field">
        <app-periodo-filtro
          modo="avancado"
          [opcoes]="opcoesPeriodo"
          [valorPadrao]="'showAll'"
          [persistir]="true"
          [textoExibicao]="periodoTransferenciaTexto"
          styleClass="w-full"
          (periodoChanged)="onPeriodoTransferenciaChanged($event)">
        </app-periodo-filtro>
      </div>
    </div>
    <!-- Seletor de colunas + Botao filtros avancados -->
    <app-column-selector
      [columns]="columns"
      [storageKey]="STORAGE_KEY"
      (columnsChange)="onColumnsChange($event)">
    </app-column-selector>
    <button pButton icon="pi pi-sliders-h"
      class="p-button-sm header-filter-btn"
      [pTooltip]="texts.filtros_avancados" tooltipPosition="top"
      (click)="sidebarFiltrosVisible = true">
    </button>
    <button pButton
      [label]="texts.nova_transferencia"
      icon="pi pi-plus"
      class="btn-primary btn-sm"
      (click)="novaTransferencia()">
    </button>
  </div>
  <div class="card-content">

    <!-- Cards de Totais por Moeda (sempre visiveis) -->
    <div class="totais-moeda-section">
      <div class="totais-moeda-cards">
        <div class="total-moeda-card total-guarani"
          *ngIf="moedasPermitidas.has('GUARANI') && (!contaBancariaAtiva || moedaContaSelecionada === 'GUARANI')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'GUARANI'"
          (click)="filtrarPorMoeda('GUARANI')">
          <div class="total-moeda-icon">
            <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_guarani }}</span>
            <span class="total-moeda-valor" [class.total-negativo]="totalGuarani < 0" *ngIf="!loadingTotais">
              Gs {{ totalGuarani | number:'1.0-0':'es-PY' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'GUARANI'"></i>
        </div>
        <div class="total-moeda-card total-dolar"
          *ngIf="moedasPermitidas.has('DOLAR') && (!contaBancariaAtiva || moedaContaSelecionada === 'DOLAR')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'DOLAR'"
          (click)="filtrarPorMoeda('DOLAR')">
          <div class="total-moeda-icon">
            <img src="assets/images/usa-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_dolar }}</span>
            <span class="total-moeda-valor" [class.total-negativo]="totalDolar < 0" *ngIf="!loadingTotais">
              $ {{ totalDolar | number:'1.2-2':'en-US' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'DOLAR'"></i>
        </div>
        <div class="total-moeda-card total-real"
          *ngIf="moedasPermitidas.has('REAL') && (!contaBancariaAtiva || moedaContaSelecionada === 'REAL')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'REAL'"
          (click)="filtrarPorMoeda('REAL')">
          <div class="total-moeda-icon">
            <img src="assets/images/br-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_real }}</span>
            <span class="total-moeda-valor" [class.total-negativo]="totalReal < 0" *ngIf="!loadingTotais">
              R$ {{ totalReal | number:'1.2-2':'pt-BR' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'REAL'"></i>
        </div>
        <div class="total-moeda-card total-peso"
          *ngIf="moedasPermitidas.has('PESO') && (!contaBancariaAtiva || moedaContaSelecionada === 'PESO')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'PESO'"
          (click)="filtrarPorMoeda('PESO')">
          <div class="total-moeda-icon">
            <img src="assets/images/argentina-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_peso }}</span>
            <span class="total-moeda-valor" [class.total-negativo]="totalPeso < 0" *ngIf="!loadingTotais">
              $ {{ totalPeso | number:'1.2-2':'es-AR' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'PESO'"></i>
        </div>
      </div>
    </div>


    <!-- Tabela -->
    <p-table [value]="transferencias" [loading]="loading"
      (sortFunction)="customSort($event)" [customSort]="true"
      [tableStyle]="{ 'width': '100%', 'margin-top': '16px' }">

      <ng-template pTemplate="header">
        <tr>
          <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 6%">
            {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('emissao')" pSortableColumn="emissao" style="width: 17%">
            {{ labels.data_emissao }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('observacao')" pSortableColumn="observacao" style="width: 17%">
            {{ labels.observacao }}<p-sortIcon [field]="'observacao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('contaOrigem')" pSortableColumn="contaOrigemDescricao" style="width: 14%">
            {{ labels.conta_origem }}<p-sortIcon [field]="'contaOrigemDescricao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('contaDestino')" pSortableColumn="contaDestinoDescricao" style="width: 14%">
            {{ labels.conta_destino }}<p-sortIcon [field]="'contaDestinoDescricao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('valorConvertido')" pSortableColumn="valorConvertido" style="width: 14%" class="num-col">
            {{ labels.valor_convertido }}<p-sortIcon [field]="'valorConvertido'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('valor')" pSortableColumn="valor" style="width: 14%" class="num-col">
            {{ labels.valor }}<p-sortIcon [field]="'valor'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">{{ labels.acoes }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-transferencia>
        <tr>
          <td [hidden]="!isColumnVisible('id')">{{ transferencia.id }}</td>
          <td [hidden]="!isColumnVisible('emissao')">{{ transferencia.emissao | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td [hidden]="!isColumnVisible('observacao')">{{ transferencia.observacao }}</td>
          <td [hidden]="!isColumnVisible('contaOrigem')">{{ transferencia.contaOrigem?.descricao || '-' }}</td>
          <td [hidden]="!isColumnVisible('contaDestino')">{{ transferencia.contaDestino?.descricao || '-' }}</td>
          <td [hidden]="!isColumnVisible('valorConvertido')" class="num-col">{{ formatarValorMonetario(transferencia.valorConvertido, transferencia.moedaDeDestino) }}</td>
          <td [hidden]="!isColumnVisible('valor')" class="num-col"
            [ngClass]="{'positive': transferencia.tipo !== 'SAIDA', 'negative': transferencia.tipo === 'SAIDA'}">
            <span *ngIf="transferencia.tipo === 'SAIDA'" class="saldo-arrow saldo-arrow--down">
              <i class="pi pi-arrow-down"></i>
            </span>
            {{ formatarValorMonetario(transferencia.valor, resolverMoedaTransferencia(transferencia)) }}
          </td>
          <td [hidden]="!isColumnVisible('acoes')" class="actions">
            <button pButton icon="pi pi-pencil"
              class="p-button-text p-button-rounded p-button-sm"
              [pTooltip]="tooltips.editar" tooltipPosition="top"
              (click)="editarTransferencia(transferencia)">
            </button>
            <button pButton icon="pi pi-trash"
              class="p-button-text p-button-rounded p-button-sm p-button-danger"
              [pTooltip]="tooltips.excluir" tooltipPosition="top"
              (click)="deletarTransferencia(transferencia.id)">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ texts.nenhuma_transferencia }}</div>
              <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ texts.carregando }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="pagination-container">
      <div>
        <p-paginator (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords"
          [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

    </p-tabPanel>

  </p-tabView>
</div>

<!-- Sidebar de Filtros Avancados -->
<p-sidebar [(visible)]="sidebarFiltrosVisible" position="right" [style]="{ width: '28rem' }" [blockScroll]="true"
    styleClass="shadow-lg">
    <ng-template pTemplate="header">
        <div class="sidebar-wave-header sidebar-wave-header--info">
            <div class="sidebar-wave-header-content">
                <div class="sidebar-wave-icon-container">
                    <i class="pi pi-sliders-h" aria-hidden="true"></i>
                </div>
                <div class="sidebar-wave-header-text">
                    <h2>{{ texts.filtros_avancados }}</h2>
                    <p>{{ texts.filtros_avancados_subtitulo }}</p>
                </div>
            </div>
            <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
            <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
            <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
            </svg>
        </div>
    </ng-template>

    <div class="sidebar-filtros-body">
        <!-- Filtro Observacao -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.filtro_observacao }}</label>
            <input type="text" pInputText [(ngModel)]="filtroObservacao"
                [placeholder]="placeholders.filtro_observacao" class="w-full" />
        </div>

    </div>

    <!-- Footer do sidebar com botoes -->
    <div class="sidebar-filtros-footer">
        <button pButton [label]="botoes.limpar_filtros"
            icon="pi pi-times" class="p-button-sm p-button-secondary"
            (click)="limparFiltros(); sidebarFiltrosVisible = false">
        </button>
        <button pButton [label]="botoes.filtrar"
            icon="pi pi-search" class="p-button-sm btn-primary"
            (click)="aplicarFiltros(); sidebarFiltrosVisible = false">
        </button>
    </div>
</p-sidebar>

<p-toast></p-toast>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de Confirmacao de Cotacao (Tolerancia) -->
<p-dialog
  [(visible)]="cotacaoDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '32rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmar_cotacao }}</h2>
        <p>{{ texts.cotacao_fora_tolerancia }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="cotacao-dialog-details">
      <div class="cotacao-detail-row">
        <span class="cotacao-detail-label">{{ texts.cotacao_do_dia_label }}</span>
        <span class="cotacao-detail-value">{{ form.cotacaoDeTransferencia | number:'1.2-4' }}</span>
      </div>
      <div class="cotacao-detail-row">
        <span class="cotacao-detail-label">{{ texts.cotacao_calculada_label }}</span>
        <span class="cotacao-detail-value">{{ cotacaoCalculadaDisplay }}</span>
      </div>
      <div class="cotacao-detail-row">
        <span class="cotacao-detail-label">{{ texts.valor_label }}</span>
        <span class="cotacao-detail-value">{{ formatarValorMonetario(form.valor!, form.moedaDeOrigem?.value) }}</span>
      </div>
      <div class="cotacao-detail-row">
        <span class="cotacao-detail-label">{{ texts.valor_convertido_label }}</span>
        <span class="cotacao-detail-value">{{ formatarValorMonetario(form.valorConvertido!, form.moedaDeDestino?.value) }}</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="cotacaoDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" icon="pi pi-check"
      (click)="confirmarSubmitComCotacao()"></button>
  </ng-template>
</p-dialog>
